import React from 'react';

const VR = () => {
    return (
        <>
            <section className="contact-page-google-map">
                <iframe
                    src="https://www.ovrlebanon.net/VirtualTours/homedepotoflebanonvirtualshowroom/"
                    className="contact-page-google-map__one" allowfullscreen></iframe>
            </section>
        </>
    )
}

export default VR